export function returnBtn(eventPath) {
    let btn = null;
    if (!eventPath || eventPath.length === 0) return btn;
    for (let i = 0; i < eventPath.length; i++) {
      if (eventPath[i].className.indexOf('el-button') !== -1) {
        btn = eventPath[i];
        break;
      }
    }
    return btn;
  }
  export  function addBtnLoading(event) {
    const btn = returnBtn(event.path || composedPath(event));
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
      const loadingIcon = document.createElement('i');
      loadingIcon.className = 'el-icon-loading';
      btn.insertBefore(loadingIcon, btn.firstChild);
      btn.blur();
    }
  }
  export function removeBtnLoading(event) {
    const btn = returnBtn(event.path || composedPath(event));
    if (btn) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      const loadingIcons = btn.querySelectorAll('.el-icon-loading');
      loadingIcons.forEach(icon => icon.parentNode.removeChild(icon));
    }
  }
  //  composedPath 兼容性问题解决方案 
  export function composedPath(event) {
    // 当前有直接return
    let pathArr = event.path || (event.composedPath && event.composedPath()); // 优先判断 Event.composedPath() 方法是否为空数组
    if ((pathArr || []).length) {
      return pathArr;
    }
    // 不存在则遍历target节点
    let target = event.target;
    event.path = [];
    while (target.parentNode !== null) {
      event.path.push(target);
      target = target.parentNode;
    }
    // 最后在add进去 document 与 window对象
    event.path.push(document, window);
    return event.path;
  }